var map = {
	"./bg-pattern-white-repeatable.png": "./png/bg-pattern-white-repeatable.png",
	"./bg-pattern-white-repeatable@2x.png": "./png/bg-pattern-white-repeatable@2x.png",
	"./bg-white-pattern-full.png": "./png/bg-white-pattern-full.png",
	"./header-conf-dark.png": "./png/header-conf-dark.png",
	"./header-conf.png": "./png/header-conf.png",
	"./hero-confetti-1.png": "./png/hero-confetti-1.png",
	"./hero-confetti-2-1.png": "./png/hero-confetti-2-1.png",
	"./hero-confetti-2.png": "./png/hero-confetti-2.png",
	"./hero-confetti-3.png": "./png/hero-confetti-3.png",
	"./hero-confetti-4.png": "./png/hero-confetti-4.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./png sync recursive \\.png$";